import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchPolicyComponent } from './search-policy/search-policy.component';
import { SearchClaimComponent } from './search-claim/search-claim.component';
import { SearchParticipantComponent } from './search-participant/search-participant.component';
import { HomeComponent } from './home.component';


const routes: Routes = [
  
  {
    path: '', component: HomeComponent, children: [
      {
        path: '', component: SearchClaimComponent
      },
      {
        path: 'search-policy', component: SearchPolicyComponent
      },
      {
        path: 'search-participant', component: SearchParticipantComponent
      }
     
     
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
